/**
 * @generated SignedSource<<979970b401f1be493ce782bded5d1bde>>
 * @relayHash 6777fb6e8bcbe8c12d0f66111b2426c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c09f0106025969df98b2f9bb12b42552cf78d592c3df0edc1325ccab4245f7e9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiBoardDeploymentDetailsPopupNewQuery } from './uiBoardDeploymentDetailsPopupNewQuery.graphql';

const node: PreloadableConcreteRequest<uiBoardDeploymentDetailsPopupNewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c09f0106025969df98b2f9bb12b42552cf78d592c3df0edc1325ccab4245f7e9",
    "metadata": {},
    "name": "uiBoardDeploymentDetailsPopupNewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
